































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { MessageThread, ThreadMember } from '@/types/messages';
import { formatDateFormat, getInitials } from '@/util';
import { Member, User } from '@/types';
import { BuyerType, EventType, ThreadType } from '@/constants';

export default Vue.extend({
  name: 'ConversationsList',
  props: {
    conversations: {
      type: Array as PropType<MessageThread[]>,
      required: true
    },
    activeConversation: {
      type: String,
      required: true
    },
    postCloseDate: {
      type: String,
      required: true
    },
    teamMembers: {
      type: Array as PropType<Member[]>,
      required: true
    },
    threadType: {
      type: String,
      required: true
    },
    coBuyers: {
      type: Array as PropType<User[]>,
      required: true
    }
  },
  data () {
    return {
      EventType,
      ThreadType
    }
  },
  computed: {
    ...mapGetters(['mileStones', 'user']),
    threads (): MessageThread[] {
      if (this.threadType === ThreadType.ALL) {
        return this.conversations;
      } else if (this.threadType === ThreadType.PRE_CLOSE) {
        return this.conversations.filter(conversation => (new Date(conversation.createdDate) < new Date(this.postCloseDate)) && !conversation.isNewMsg);
      } else {
        return this.conversations.filter(conversation => (new Date(conversation.createdDate) > new Date(this.postCloseDate)) || conversation.isNewMsg);
      }
    }
  },
  methods: {
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    formatDate (date: string) {
      if (formatDateFormat(new Date(), 'YYYY-MM-DD') === formatDateFormat(date, 'YYYY-MM-DD')) {
        return 'Today';
      } else {
        return formatDateFormat(date, 'MMM DD, YYYY');
      }
    },
    isLoggedInUser (email: string, type: string) {
      return this.user.email.toLowerCase() === email.toLowerCase() && type === BuyerType.BUYER;
    },
    chatRecipients (members: ThreadMember[]) {
      return members.filter(member => !this.isLoggedInUser(member.email, member.type));
    },
    isActiveThreadPostClose (thread: MessageThread): boolean {
      return this.threadType === ThreadType.ALL ? true : new Date(thread.createdDate) > new Date(this.postCloseDate);
    },
    isThreadOpen (thread: MessageThread) {
      const threadTeamMembers = thread.members.filter(members => members.type === 'ADMIN');
      return threadTeamMembers.every(member => this.teamMembers.findIndex(teamMember => teamMember.email === member.email) > -1) && this.isActiveThreadPostClose(thread);
    },
    isActive (member: ThreadMember): boolean {
      return member.type === BuyerType.BUYER ? this.coBuyers.findIndex(coBuyer => coBuyer.email === member.email) > -1 : true;
    }
  }
});
